import { render, staticRenderFns } from "./DecimalSetting.vue?vue&type=template&id=7d9bb37e&scoped=true&"
import script from "./DecimalSetting.vue?vue&type=script&lang=js&"
export * from "./DecimalSetting.vue?vue&type=script&lang=js&"
import style0 from "./DecimalSetting.vue?vue&type=style&index=0&id=7d9bb37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9bb37e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VDialog,VIcon,VRow,VSelect,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d9bb37e')) {
      api.createRecord('7d9bb37e', component.options)
    } else {
      api.reload('7d9bb37e', component.options)
    }
    module.hot.accept("./DecimalSetting.vue?vue&type=template&id=7d9bb37e&scoped=true&", function () {
      api.rerender('7d9bb37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Settings/DecimalSetting.vue"
export default component.exports